// Route guard. Renders children if signed in; redirects to /login
// otherwise. Shows a brief loading state while the initial refresh
// is in flight.

import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from './AuthContext.js';

export function RequireAuth({ children }: { children: ReactNode }): JSX.Element {
  const auth = useAuth();
  const location = useLocation();

  if (auth.status === 'loading') {
    return <div className="page-loading">Loading…</div>;
  }
  if (auth.status === 'signed_out') {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
